import React from "react";

import { Chart as ChartJS } from "chart.js/auto";
import { Chart } from "react-chartjs-2";
import { Line, Bar, Doughnut } from "react-chartjs-2";

const grafico = (props) => {
  const _datos = props.datos;
  const _etiquetas = props.etiquetas;
  const data1 = {
    label: "Derivaciones",
    data: _datos,
    borderColor: "rgb(200, 200, 200)",
    backgroundColor: "rgba(255, 99, 132, 0.5)",
    pointBackgroundColor: "rgba(255, 99, 132, 0.5)",
    pointBorderColor: "rgb(255, 99, 132)",
  };

  const _data = {
    labels: ["Apto", "No Apto"],
    datasets: [
      {
        label: "# of Votes",
        data: _datos,
        backgroundColor: ["rgba(61, 133, 166, 0.8)", "rgba(186, 69, 42, 0.8)"],
        borderColor: ["rgba(61, 133, 166, 1)", "rgba(186, 69, 42, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const _options = {
    responsive: true,
    cutout: "80%",
    layout: {
      padding: {
        bottom: 30,
      },
    },
    plugins: {
      // legend: {
      //   display: true,
      //   position: "right",
      // },
      legend: {
        display: true,
        position: "bottom",
        align: "start",

        labels: {
          font: { size: 13.6, weight: "bold" },
          padding: 20,
          generateLabels: (chart) => {
            const datasets = chart.data.datasets;
            return datasets[0].data.map((data, i) => ({
              text: `${data} : ${chart.data.labels[i]} `,
              fillStyle: datasets[0].backgroundColor[i],
              borderColor: datasets[0].borderColor[i],
              borderWidth: 5,
              index: i,
            }));
          },
        },
      },

      title: {
        display: false,
        text: "Resultados ",
      },
    },
  };

  return <Doughnut data={_data} options={_options}></Doughnut>;
};

const GraficoPregunta = (props) => {
  //console.log(props);
  return <div>{grafico(props)}</div>;
};

export default GraficoPregunta;
